import type { ContentStoryblok } from "@/types/storyblok-blok-types";

import UI from "./UI";

const Body = ({ blok, ...restProps }: { blok: ContentStoryblok, restProps: any }) => {
  return <UI blok={blok} {...restProps} />;
};

export default Body;
